module.exports = __webpack_public_path__ + "static/media/schody44 - schody drewniane nakladane.c65a6ea3.jpg";